import { Theme } from '@mui/material';
import { Colors } from '@sweatpals/react-ui-kit';

export const upgradeTicketFormModalStyles = (theme: Theme) => ({
	closeIcon: {
		color: Colors.white,
		border: '1px solid #FFFFFF66',
		width: '48px',
		height: '48px',

		'&.Mui-disabled': {
			color: Colors.white_a60,
		}
	},
});
